import { FC } from 'react';
import { SubmitButton } from 'src/general/components/Button/SubmitButton';

type Props = {
  label?: string;
};

export const AuthFormSubmit: FC<Props> = ({ label = 'Continue' }) => (
  <footer className="my-6">
    <SubmitButton fullWidth data-testid="StepForm-submit">
      {label}
    </SubmitButton>
  </footer>
);
